// extracted by mini-css-extract-plugin
export var standaloneTable = "_eh-0";
export var standaloneTableWithBodyFill = "_eh-1";
export var withExtraHeader = "_eh-2";